import errorMark from "@app/assets/images/error-mark.svg";
import successTick from "@app/assets/images/wizard-last-step.svg";
import { Modal } from "@app/components";
import { links } from "@app/constants";
import { Button } from "@app/controls";
import type { RootState } from "@app/redux";
import { appendString } from "@app/utils";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import type { Properties } from "./properties";
import "./status-modal.css";
import "./status-modal.responsive.css";

const StatusModalView = React.memo((props: Properties) => {
	const { language } = useSelector(
		(rootState: RootState) => rootState.language,
	);

	const getStatusIcon = () => {
		const errorIcon = (
			<img className="mx-auto" src={errorMark} alt="error-mark" />
		);
		const successIcon = (
			<img className="mx-auto" src={successTick} alt="success-tick" />
		);

		if (!props.status) {
			return undefined;
		}

		switch (props.status) {
			case "ERROR": {
				return errorIcon;
			}
			case "SUCCESS": {
				return successIcon;
			}
			case "GENERAL":
			default: {
				return undefined;
			}
		}
	};

	const getStatusHeading = () => {
		if (props.heading) {
			return props.heading;
		}

		const generalMessage = messages[language].information;

		if (!props.status) {
			generalMessage;
		}

		switch (props.status) {
			case "ERROR": {
				return messages[language].error;
			}
			case "SUCCESS": {
				return messages[language].success;
			}
			case "GENERAL":
			default: {
				return generalMessage;
			}
		}
	};

	const agreementStyle = [
		"font-primary-regular",
		"mt-4",
		"text-center",
		props.messageClassName,
	].join(" ");

	const buttonStyle = ["font-primary-medium", "pt-3", "pb-3"].join(" ");

	const containerStyle = ["flex", "flex-col", "max-w-max", "gap-y-6"].join(" ");

	const headingStyle = [
		"font-primary-bold",
		"mb-3",
		"text-center",
		"status-modal-header",
		props.headingClassName,
	].join(" ");

	// #region CONSTANTS
	const isErrorStatus = props.status === "ERROR";

	return (
		<Modal
			className={["status-modal", props.className].join(" ")}
			open={props.open}
			noCloseButton={
				props.showCloseButton === undefined ? true : !props.showCloseButton
			}
			onClose={props.showCloseButton ? props.onClose : undefined}
		>
			<div className={containerStyle}>
				{getStatusIcon()}
				<h1 className={headingStyle}>{getStatusHeading()}</h1>

				<div className={agreementStyle}>
					<label className="status-modal-contact">
						{(props.message
							? appendString(props.message, isErrorStatus ? "." : "", false)
							: "") +
							" " +
							(isErrorStatus ? messages[language].contact.resolve : "")}
						{isErrorStatus && (
							<a
								href={links.getInTouch.emailAddress}
								target="_blank"
								rel="noreferrer"
							>
								{messages[language].contact.email}
							</a>
						)}
					</label>
				</div>
				<Button className={buttonStyle} theme="primary" onClick={props.onClose}>
					{props.buttonContent ?? messages[language].button}
				</Button>
			</div>
		</Modal>
	);
});

export { StatusModalView };
